import { post } from '../../../../DAL/data-provider';
import {Response, SetupRecordWrapper, SFContactWrapper} from '../interfaces';

export const sendForm = async (sfWrap: SFContactWrapper) : Promise<Response> => {
    //console.log(`sendForm:`,sfWrap);
    return post('/api/salesforcecontact/send-form', sfWrap);
};
export const sendSetup = async (setupRecordWrap:SetupRecordWrapper) : Promise<Response> => {
    //console.log(`sendSetup:`,setupRecordWrap);
    return post('/api/salesforcecontact/send-setup', setupRecordWrap);
};
